import BaseDialogTitle from "../../../../../components/dialog/BaseDialogTitle";
import {Dialog, DialogContent, Divider} from "@mui/material";
import CompanyCuitSyncDialogContent from "./CompanyCuitSyncDialogContent";



interface CompanyCuitSyncDialogProps {
    open: boolean,
    onClose: () => void,
    subtitle: string,
    saveClient?: boolean,
    onSave?: () => void
}


const CompanyCuitSyncDialog = ({ open, onClose, subtitle, saveClient, onSave }: CompanyCuitSyncDialogProps) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth={'md'} fullWidth>
            <BaseDialogTitle title={'Agregar empresa'} onClose={onClose} />
            <Divider />
            <DialogContent>
                <CompanyCuitSyncDialogContent subtitle={subtitle}
                                              saveClient={saveClient}
                                              onSave={onSave}
                                              action={onClose}
                />
            </DialogContent>
        </Dialog>
    )
}


export default CompanyCuitSyncDialog